import { render } from "./moh405.vue?vue&type=template&id=65a64224&scoped=true"
import script from "./moh405.vue?vue&type=script&lang=js"
export * from "./moh405.vue?vue&type=script&lang=js"

import "./moh405.vue?vue&type=style&index=0&id=65a64224&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a64224"]])

export default __exports__